import { Box, Grid, Typography } from "@mui/material";
import CompanyTypeBadge from "@entrilia/shared/components/CompanyTypeBadge";
import type { ClientInfo } from "../../../api/types/clientTypes";
import ClientIcon from "./ClientIcon";

interface Props {
  client: ClientInfo;
  clientOrganization?: ClientInfo;
}

const ClientSelectorValue = ({ client, clientOrganization }: Props) => (
  <Grid container spacing={1} sx={{ alignItems: "center", flexWrap: "nowrap" }}>
    <ClientIcon clientType={client.type} logoUrl={client.branding.logoMarkUrl} color="white" />
    <Box
      sx={{
        ml: 1,
        display: "grid",
        flex: 1,
        minWidth: 0,
        ">.MuiTypography-root": { whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
      }}
    >
      {/* Explicit colors: the Select input is styled by the outer browser-mode theme, so plain inheritance leaks light text here. */}
      <Typography color="textPrimary">{client.title}</Typography>
      {clientOrganization && (
        <Typography variant="caption" color="textSecondary">
          {clientOrganization.title}
        </Typography>
      )}
    </Box>
    {client.type === "FundManager" && (
      <Box sx={{ display: "flex" }}>
        <CompanyTypeBadge type={client.companyType} />
      </Box>
    )}
  </Grid>
);

export default ClientSelectorValue;
